// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoomSizeSection-module__main--lSIhV {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 36px;
    grid-auto-flow: row;
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/RoomSetup/RoomSizeSection.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,0BAA0B;IAC1B,wBAAwB;IACxB,mBAAmB;AACvB","sourcesContent":[".main {\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: 36px;\n    grid-auto-flow: row;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `RoomSizeSection-module__main--lSIhV`
};
export default ___CSS_LOADER_EXPORT___;
